module.exports = __webpack_public_path__ + "img/28.30920961.webp";